(function(){
  if(window.__zionCart) return; window.__zionCart = true;
  var $ = function(s, r){ return (r || document).querySelector(s); };
  var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var brl = function(c){ return (c / 100).toLocaleString('pt-BR', {style:'currency', currency:'BRL'}); };
  var esc = function(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;'}[c]; }); };
  var pixOf = function(c){ return Math.round(c * (100 - PIX) / 100); };
  var PIX = 5, PARC = 12, SJ = 0, JUROS = [0, 9.64, 11.23, 11.36, 14.31, 14.32, 16.72, 16.73, 19.69, 20.65, 20.66, 22.11], DMIN = 5, DMAX = 12;
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8-4.2-4.1 5.8-.8z"/></svg>', ICHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>', ESTR = false;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* aviso global (window.zionToast): mesmo visual/comportamento do toast da PDP (04-product.py avisa()). */
  if(!window.zionToast){
    var ztEl = document.createElement('div'), ztTimer = 0;
    ztEl.className = 'zion-toast'; ztEl.setAttribute('role', 'status'); ztEl.setAttribute('aria-live', 'polite');
    var ztPop = 'showPopover' in ztEl; if(ztPop) ztEl.setAttribute('popover', 'manual');
    var ztMount = function(){ document.body.appendChild(ztEl); };
    if(document.body) ztMount(); else document.addEventListener('DOMContentLoaded', ztMount);
    window.zionToast = function(html, link){
      /* 05/10/2026: com o carrinho lateral aberto, ele mesmo é a confirmação da adição; o aviso só duplicava e cobria o cabeçalho */
      var ztDr = !!document.querySelector('dialog.theme-drawer__dialog[open], cart-drawer-component dialog[open]');
      if(ztDr && /^Adicionado/.test(html || '')) return;
      if(html && link && link.href) html += ' <a href="' + link.href + '">' + (link.linkText || '') + '</a>';
      clearTimeout(ztTimer); ztEl.innerHTML = html;
      ztEl.classList.toggle('is-top', !!document.querySelector('dialog.theme-drawer__dialog[open], cart-drawer-component dialog[open]'));
      if(ztPop){ try{ if(ztEl.matches(':popover-open')) ztEl.hidePopover(); ztEl.showPopover(); }catch(_){} }
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ ztEl.classList.add('is-on'); }); });
      ztTimer = setTimeout(function(){ ztEl.classList.remove('is-on'); ztTimer = setTimeout(function(){ if(ztPop){ try{ ztEl.hidePopover(); }catch(_){} } }, 260); }, 3200);
    };
  }

  function toCents(s){
    s = String(s || '').replace(/[^\d.,]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
    var n = parseFloat(s); return isFinite(n) ? Math.round(n * 100) : 0;
  }
  function simular(price){
    var rows = [];
    for(var n = 1; n <= PARC; n++){
      var tot = n <= Math.max(SJ, 1) ? price : Math.round(price * (1 + JUROS[n - 1] / 100));   /* tabela do Mercado Pago (_comercial.MP_JUROS) */
      rows.push({n:n, parcela:Math.round(tot / n), total:tot});
    }
    return rows;
  }
  function setHTML(el, html){ if(el.innerHTML !== html) el.innerHTML = html; }
  function drawer(){ return document.getElementById('cart-drawer'); }
  function pageCart(){ return $('.cart-page'); }
  /* raízes com itens: o drawer (quando não vazio) e a página /cart (quando não vazia) */
  function roots(){
    var r = [], d = drawer(), p = pageCart();
    if(d && $('.cart-drawer__items', d) && !$('.cart-drawer--empty', d)) r.push({el:d, kind:'d', items:$('.cart-drawer__items', d), sug:$('.cart-drawer__content', d)});   /* 29/10 (C2): sugestões no fim do conteúdo, DEPOIS do resumo (CSS order) */
    /* /cart: sugestões são filho direto de .cart-page (linha inteira abaixo de itens + resumo, CSS grid-column 1/-1) */
    if(p && !p.classList.contains('cart-page--empty') && $('.cart-page__items', p)) r.push({el:p, kind:'p', items:$('.cart-page__items', p), sug:p});
    return r;
  }
  function rows(root){ return $$('.cart-items__table-row[data-key]', root); }
  function handleOf(tr){ var a = $('.cart-items__title', tr), m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  /* JSON enxuto por produto (/products/<h>?view=zcart, gerado por 29-carrinho.py): cache por página */
  var ZC = {}, ZP = {};
  function getZ(h){
    if(!h) return Promise.resolve(null);
    if(!ZP[h]) ZP[h] = fetch('/products/' + encodeURIComponent(h) + '?view=zcart').then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ ZC[h] = j; return j; }).catch(function(){ ZC[h] = null; return null; });
    return ZP[h];
  }

  /* 1) headline: label mono "CARRINHO / 02" + "Sua seleção." (200, última palavra 600 com traço cobre); vazio = "... vazio." */
  function wrapLast(el){
    if(!el || $('strong', el)) return;
    var t = el.textContent.replace(/\s+/g, ' ').trim(); if(!t) return;
    var i = t.lastIndexOf(' ');
    el.innerHTML = i < 0 ? '<strong>' + esc(t) + '</strong>' : esc(t.slice(0, i)) + ' <strong>' + esc(t.slice(i + 1)) + '</strong>';
  }
  function head(h, root){
    if(!h) return;
    var n = 0; $$('input[data-cart-quantity], .cart-items__quantity input', root).forEach(function(i){ n += (+i.value || 0); });
    if(!n) return;
    /* rodada 2: 1 linha "Seu carrinho · N item(s)" (mesmo texto do servidor, zion-cart-ssr 'head') */
    var nn = String(n), k = $('.zion-ch-n', h);
    if(k && k.dataset.n === nn && h.classList.contains('zion-ch')) return;
    h.classList.add('zion-ch');
    Array.prototype.slice.call(h.childNodes).forEach(function(c){ if(c.nodeType === 3 && c.textContent.trim()) c.textContent = ''; });
    $$('.zion-ch-k', h).forEach(function(x){ x.remove(); });
    var t = $('.zion-ch-t', h);
    if(!t){ h.insertAdjacentHTML('afterbegin', '<span class="zion-ch-t">Seu carrinho</span>'); t = $('.zion-ch-t', h); }
    else if(t.textContent !== 'Seu carrinho') t.textContent = 'Seu carrinho';
    if(!k){ t.insertAdjacentHTML('afterend', '<span class="zion-ch-n"></span>'); k = $('.zion-ch-n', h); }
    k.dataset.n = nn; k.textContent = '· ' + n + (n === 1 ? ' item' : ' itens');
  }
  function headlines(){
    var d = drawer(), p = pageCart();
    if(d){
      wrapLast($('.cart-drawer--empty .cart-drawer__content .theme-drawer__title', d));
      if(!$('.cart-drawer--empty', d)) head($('.theme-drawer__header .theme-drawer__title', d), d);
    }
    if(p){
      if(p.classList.contains('cart-page--empty')) wrapLast($('.cart-title h1', p));
      else head($('.cart-title h1', p), p);
    }
  }

  /* estrelas: com avaliação real (rc > 0) = cheias pela nota; sem avaliação = 5 vazadas (ESTRELAS_ESTRUTURA) ou nada */
  function estrelas(z, cls){
    if(!z) return '';
    if(!(z.rc >= 3)){
      if(!ESTR) return '';
      var e = ''; for(var j = 0; j < 5; j++) e += '<span>' + STAR + '</span>';
      return '<p class="' + cls + '" role="img" aria-label="Ainda sem avaliações">' + e + '</p>';
    }
    var st = '', r = Math.round(z.rv);
    for(var i = 1; i < 6; i++) st += '<span' + (r >= i ? ' class="is-on"' : '') + '>' + STAR + '</span>';
    return '<p class="' + cls + '" role="img" aria-label="' + r + ' de 5 estrelas (' + z.rc + ')">' + st + '</p>'
      + '<b class="zion-ci-nota" aria-hidden="true">' + (Math.round(z.rv * 10) / 10).toFixed(1).replace('.', ',') + '</b><span class="zion-ci-nn" aria-hidden="true">(' + z.rc + ')</span>';
  }

  /* 2) linha do item: Pix (mono cobre) sob o total, no topo à direita; benefício real (spec.beneficio + ícone do território) sob o título */
  function linhas(root){
    rows(root.el).forEach(function(tr){
      var q = $('.cart-items__quantity input', tr), q1 = q && +q.value === 1 && !$('.cart-items__unit-price-wrapper s', tr);
      if(tr.classList.contains('zion-q1') !== !!q1) tr.classList.toggle('zion-q1', !!q1);
      var td = $('.cart-items__price', tr), tc = td && $('text-component', td);
      if(tc){
        var extra = $('.zion-ci-extra', td);
        if(!extra){ extra = document.createElement('div'); extra.className = 'zion-ci-extra'; td.appendChild(extra); }
        setHTML(extra, '<p class="zion-ci-pix"><b>' + brl(pixOf(toCents(tc.getAttribute('value')))) + '</b> <span>no Pix</span></p>');
      }
      if(tr.hasAttribute('data-zssr')) return;   /* sobrelinha/espécie/benefício já vieram do servidor (zion-cart-ssr.liquid) */
      var h = handleOf(tr); if(!h) return;
      if(!(h in ZC)){ getZ(h).then(schedule); return; }
      var z = ZC[h]; if(!z) return;
      var pi = $('.cart-items__product-info', tr);
      /* sobrelinha (estrelas só com avaliação + território) acima do título; espécie (tags) no fim da leitura */
      if(pi && !$('.zion-ci-eb', tr)){
        var eb = estrelas(z, 'zion-sel__stars zion-ci-stars') + (z.ty ? '<span class="zion-ci-eb__ty">' + esc(z.ty) + '</span>' : '');
        if(eb) pi.insertAdjacentHTML('afterbegin', '<div class="zion-ci-eb">' + eb + '</div>');
      }
      var sp = z.sp || [], dt = $('.cart-items__details', tr);
      if(sp.length && dt && !$('.zion-ci-sp', dt)) dt.insertAdjacentHTML('beforeend', '<p class="zion-ci-sp">' + ICHECK + '<span>Serve para <b>' + (sp.length > 1 ? 'cães e gatos' : esc(sp[0].toLowerCase())) + '</b></span></p>');
      var html = z.bh || ''; if(!html || $('.zion-ci-ben', tr)) return;
      var host = $('.cart-items__variants-wrapper', tr) || $('.cart-items__product-info', tr); if(!host) return;
      var b = document.createElement('div'); b.className = 'zion-ci-ben'; b.innerHTML = html; host.insertBefore(b, host.firstChild); host.classList.add('zion-hb');   /* zion-hb/zion-hv: classes no lugar do :has() (19/10) */
    });
  }

  /* 3) selos: vêm do servidor (zion-cart-ssr 'seals', sob as bandeiras). Aqui só repõe se faltar (ex.: resumo re-renderizado sem o snippet). */
  function selos(){
    roots().forEach(function(root){
      if($('.zion-cart-seals', root.el)) return;
      var pay = $('.zion-cart-pay', root.el); if(pay) pay.insertAdjacentHTML('afterend', '<ul class="zion-cart-seals" aria-label="Garantias da compra"><li><a href="/pages/trocas-e-devolucoes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9a8 8 0 0 1 14.5-3M20 15a8 8 0 0 1-14.5 3"/><path d="M18.5 2.5V6H15M5.5 21.5V18H9"/></svg><b>7 dias</b><span>devolução grátis</span></a></li><li><a href="/pages/trocas-e-devolucoes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 3l7 3v5.5c0 4.5-3 8-7 9.5-4-1.5-7-5-7-9.5V6z"/><path d="M9 12l2.2 2.2L15.5 10"/></svg><b>90 dias</b><span>de garantia</span></a></li><li><div><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5v-3a4 4 0 0 1 8 0v3"/></svg><b>Seguro</b><span>Mercado Pago</span></div></li></ul>');
    });
  }

  /* 4) checkout: ícone fora do fluxo (CSS) + estado "indo" */
  function botoes(){
    $$('#checkout').forEach(function(co){
      if(!co.closest('#cart-drawer, .cart-page')) return;
      co.classList.add('zion-cart-checkout');
      if(!$('.icon-cart-svg', co)){ co.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5v-3a4 4 0 0 1 8 0v3"/></svg>'); $('svg', co).classList.add('icon-cart-svg'); }
    });
  }
  function indo(co){ if(co.dataset.zGoing) return; co.dataset.zGoing = '1'; co.classList.add('is-going'); var bt = $('.button-text', co); if(bt) bt.textContent = 'Indo para o checkout…'; }
  /* 19/10/2026 (lacuna #48): o +/− do Horizon só dispara o update 300 ms depois do toque (debounce) e o CTA é submit nativo: tocar em Finalizar nessa
     janela abria o checkout com o carrinho ANTIGO. Se houve toque na quantidade há < 500 ms ou há update pendente, segura o clique, espera o debounce
     (350 ms) + os updates em voo (CartItemsComponent.pendingQuantityUpdates) e só então reenvia o clique (zGo = passa direto). Teto de 6 s. */
  var lastQty = 0;
  ['click', 'input', 'change'].forEach(function(n){ document.addEventListener(n, function(e){ if(e.target.closest && e.target.closest('.cart-items__quantity')) lastQty = Date.now(); }, true); });
  document.addEventListener('click', function(e){
    var co = e.target.closest('.zion-cart-checkout'); if(!co || co.__zGo) return;
    var C = customElements.get('cart-items-component'), pend = (C && C.pendingQuantityUpdates) || [];
    if(!pend.length && Date.now() - lastQty > 500) return;
    e.preventDefault(); e.stopImmediatePropagation(); indo(co);
    var drain = function(){ var p = C && C.pendingQuantityUpdates; return p && p.length ? Promise.all(p).then(drain, drain) : Promise.resolve(); };
    Promise.race([new Promise(function(r){ setTimeout(r, 350); }).then(drain), new Promise(function(r){ setTimeout(r, 6000); })])
      .catch(function(){}).then(function(){ co.__zGo = 1; co.click(); });
  }, true);
  document.addEventListener('click', function(e){
    var co = e.target.closest('.zion-cart-checkout');
    if(co) indo(co);
  });

  /* 5) barra de frete grátis no TOPO. Drawer: anexada no FIM de .cart-drawer__content e subida com CSS order
     (nunca entre .cart-drawer__items e .cart-drawer__summary: o morph do Horizon perde o resumo). Vazio = sem barra. */
  function frete(){
    var html = '<p><span class="zion-fbar__ok" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><span>Frete grátis · ' + DMIN + ' a ' + DMAX + ' dias úteis · seguro e rastreio</span></p>';
    var d = drawer();
    if(d){
      $$('.cart-drawer__items > .zion-fbar, .cart-drawer--empty .zion-fbar', d).forEach(function(n){ n.remove(); });
      var content = !$('.cart-drawer--empty', d) && $('.cart-drawer__content', d);
      if(content && !$(':scope > .zion-fbar', content)){ var w = document.createElement('div'); w.className = 'zion-fbar'; w.innerHTML = html; content.appendChild(w); }
    }
    var p = pageCart();
    if(p && !p.classList.contains('cart-page--empty')){
      var items = $('.cart-page__items', p);
      if(items && !$(':scope > .zion-fbar', items)){ var w2 = document.createElement('div'); w2.className = 'zion-fbar'; w2.innerHTML = html; items.insertBefore(w2, items.firstChild); }
    }
  }

  /* 6) "Ver parcelas" do total do carrinho (drawer; mesma lógica/visual da PDP) */
  function parcelasTotal(){
    roots().forEach(function(root){
      var tot = $('[data-cart-subtotal]', root.el); if(!tot) return;
      var wrap = tot.closest('.cart-totals__total'); if(!wrap || $('.zion-cart-parclink', wrap)) return;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'zion-cart-parclink'; b.textContent = 'Ver parcelas'; wrap.appendChild(b);
    });
  }
  document.addEventListener('click', function(e){
    var pl = e.target.closest('.zion-cart-parclink');
    if(pl){
      var tw = pl.closest('.cart-totals__total'), tot = tw && $('[data-cart-subtotal]', tw);
      var cents = pl.dataset.c ? +pl.dataset.c : tot ? toCents(tot.getAttribute('value')) : 0; if(!cents) return;
      var dlg = $('[data-zion-cartparc]');
      $('[data-zion-cartparcpix]', dlg).textContent = brl(pixOf(cents));
      $('[data-zion-cartparcrows]', dlg).innerHTML = simular(cents).map(function(r){
        var sj = r.total <= cents;
        return '<tr><td>' + r.n + 'x' + (sj ? '' : '*') + '</td><td>' + brl(r.parcela) + '</td><td>' + brl(r.total) + '</td></tr>';
      }).join('');
      dlg.showModal();
    } else if(e.target.closest('[data-zion-cartparcclose]')){
      var open = $('[data-zion-cartparc][open]'); if(open) open.close();
    } else if(e.target.matches && e.target.matches('[data-zion-cartparc]')){
      e.target.close();
    }
  });

  /* 8) barra compacta fixa no fundo da gaveta: total + Pix + Finalizar sempre à vista (05/10/2026, Everton). O botão dela
     clica o checkout real (mesmo form, mesmo estado "Indo para o checkout…"). Anexada no FIM de .cart-drawer__content
     (regra do morph, ver 5). Some enquanto os botões reais estão visíveis. */
  var cbarIO = null, cbarAlvo = null;
  function barraFinal(){
    var d = drawer(); if(!d) return;
    var content = !$('.cart-drawer--empty', d) && $('.cart-drawer__content', d);
    var bar = content && $(':scope > .zion-cbar', content);
    var tot = content && $('.cart-drawer__summary [data-cart-subtotal]', content), ctas = content && $('.cart-drawer__summary .cart__ctas', content);
    if(!content || !tot || !ctas){ $$('.zion-cbar', d).forEach(function(n){ n.remove(); }); return; }
    if(!bar){
      bar = document.createElement('div'); bar.className = 'zion-cbar is-off';
      bar.innerHTML = '<div class="zion-cbar__in"><button type="button" class="button cart__checkout-button zion-cbar__go"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5v-3a4 4 0 0 1 8 0v3"/></svg><span class="button-text">Finalizar compra</span><small class="zion-fin__s"></small></button></div>';
      $('svg', bar).classList.add('icon-cart-svg');
      content.appendChild(bar);
    }
    var inn = $('.zion-cbar__in', bar), h = inn ? inn.offsetHeight + 'px' : '0px';
    if(bar.style.getPropertyValue('--zcbh') !== h) bar.style.setProperty('--zcbh', h);
    /* 29/10 (auditoria final Codex/Fable): liga quando o BOTÃO de finalizar não está inteiro na tela. Antes olhava o resumo inteiro:
       com 2 itens + gancho, o total aparecia e o botão ficava abaixo da dobra sem barra (cliente via o total sem ver como pagar).
       O espaço da barra fica reservado no fim da rolagem (--zcbh), então nada do resumo fica inacessível. */
    var sum = ctas;
    if(cbarAlvo !== sum && 'IntersectionObserver' in window){
      if(cbarIO) cbarIO.disconnect();
      cbarAlvo = sum;
      cbarIO = new IntersectionObserver(function(es){ var b = $('#cart-drawer .zion-cbar'); if(b) b.classList.toggle('is-off', es[0].intersectionRatio >= 0.99); }, {root: content, threshold: 0.99});
      cbarIO.observe(sum);
    }
  }
  document.addEventListener('click', function(e){
    if(!e.target.closest('.zion-cbar__go')) return;
    var real = $('#cart-drawer .cart-drawer__summary .cart__checkout-button'); if(real) real.click();
  });

  /* 7) cupom discreto: rótulo "Tem outro cupom?" (accordion nativo). 29/10 (C10): o PIX5 é colado no checkout (linha do Pix);
     o campo daqui fica para outros códigos — "Tem cupom?" contradizia o "cole no checkout". */
  function cupom(){
    roots().forEach(function(root){ $$('.cart-discount__label', root.el).forEach(function(l){ if(l.dataset.zionCupom) return; l.dataset.zionCupom = '1'; l.textContent = 'Tem outro cupom?'; }); });
  }

  /* 7b) resumo: linha "Total no Pix" (a do zion-mm.js escreve "No Pix 5% OFF"; aqui volta ao texto da casa), "Finalizar compra · N itens · R$ X no Pix"
     e bandeiras sob o botão. Tudo DENTRO do resumo, nunca entre itens e resumo. */
  function fin(root){
    var tot = $('[data-cart-subtotal]', root.el); if(!tot) return;
    var n = 0; $$('.cart-items__quantity input', root.el).forEach(function(i){ n += (+i.value || 0); });
    if(!n) return;
    var t = n + (n === 1 ? ' item' : ' itens') + ' · ' + brl(pixOf(toCents(tot.getAttribute('value')))) + ' no Pix';
    $$('.zion-fin__s', root.el).forEach(function(x){ if(x.textContent !== t) x.textContent = t; });
  }
  function resumo(){
    roots().forEach(function(root){
      $$('.zion-cartpix[data-c]', root.el).forEach(function(l){ if(!$('i', l)) l.innerHTML = '<span>Total</span><em>' + PIX + '% OFF' + '</em><b>' + brl(+l.dataset.c) + '</b><i>no Pix</i>'; });
      fin(root);
      var ctas = $('.cart__ctas', root.el), tpl = document.getElementById('zion-cart-pay');
      if(ctas && tpl && !$('.zion-cart-pay', root.el)) ctas.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    });
  }

  document.addEventListener('click', function(e){
    var b = e.target.closest('.zion-cpm__b'); if(!b) return;
    var c = $('.zion-cpm__c', b), ok = function(){ c.textContent = 'Copiado'; setTimeout(function(){ c.textContent = 'PIX5'; }, 2000); };
    if(navigator.clipboard && window.isSecureContext){ navigator.clipboard.writeText('PIX5').then(ok, ok); return; }
    var t = document.createElement('textarea'); t.value = 'PIX5'; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;opacity:0';
    document.body.appendChild(t); t.select(); try{ document.execCommand('copy'); }catch(_){} t.remove(); ok();
  });

  /* 8) checkout acelerado (Shop Pay etc.): condicional puro */
  function acelerado(){
    var d = drawer(); if(!d) return;
    var tpl = document.getElementById('zion-cart-accel'); if(!tpl) return;
    var box = $('.cart__ctas', d); if(!box || $('.zion-cart-accel', d)) return;
    var frag = tpl.content.cloneNode(true); if(!frag.firstElementChild) return;
    box.parentNode.insertBefore(frag, box);
  }

  /* 9) trocar variante direto na linha (drawer): /cart/change.js + /cart/add.js + re-render do drawer pela Section Rendering API.
     A linha nova entra no fim (a Ajax Cart API não reordena linhas). */
  function variantes(){
    var d = drawer(); if(!d) return;
    $$('.cart-items__table-row[data-key]', d).forEach(function(tr){
      if(tr.dataset.zionVsel) return; tr.dataset.zionVsel = '1';
      var a = $('.cart-items__title', tr); if(!a) return;
      var href = a.getAttribute('href') || '', m = href.match(/\/products\/([^/?]+)/); if(!m) return;
      var vm = href.match(/variant=(\d+)/), curId = vm ? +vm[1] : null;
      fetch('/products/' + m[1] + '.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
        if(!p || !p.variants || p.variants.length < 2 || !document.body.contains(tr)) return;
        if(!curId) curId = p.variants[0].id;
        var sel = document.createElement('select'); sel.className = 'zion-cart-vsel'; sel.setAttribute('aria-label', 'Trocar variante');
        sel.innerHTML = p.variants.map(function(v){
          return '<option value="' + v.id + '"' + (v.id === curId ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (indisponível)') + '</option>';
        }).join('');
        sel.addEventListener('change', function(){
          var novo = +sel.value; if(novo === curId) return;
          var qtyInput = $('input[data-cart-quantity]', tr), qtd = qtyInput ? (+qtyInput.value || 1) : 1;
          sel.disabled = true;
          fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: tr.dataset.key, quantity: 0})})
            .then(function(){ return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: novo, quantity: qtd})}); })
            .then(function(){ return fetch('/?sections=cart-drawer-section'); })
            .then(function(r){ return r.json(); })
            .then(function(j){
              var html = j && j['cart-drawer-section']; if(!html){ location.reload(); return; }
              var novoDom = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-cart-drawer-section');
              var atual = document.getElementById('shopify-section-cart-drawer-section');
              if(novoDom && atual) atual.replaceWith(novoDom);
              var trig = document.querySelector('[aria-controls="cart-drawer"]'); if(trig) trig.click();
              if(window.zionToast) window.zionToast('Variante trocada');
              schedule();
            })
            .catch(function(){ location.reload(); });
        });
        var host2 = $('.cart-items__variants-wrapper', tr) || $('.cart-items__product-info', tr);
        if(host2){ host2.appendChild(sel); host2.classList.add('zion-hv'); }
      }).catch(function(){});
    });
  }

  /* 10) carrossel de sugestões (decisão). Fonte: recomendações nativas da Shopify (/recommendations/products.json,
     intent=complementary; sem complemento cadastrado, related) dos 2 primeiros itens do carrinho — a mesma fonte do
     carrossel anterior. Tira o que já está no carrinho e o que está esgotado. "Por que combina" só com fato derivável:
     complemento cadastrado pela loja, mesmo território (tipo do produto) ou mesma espécie (tags Cães/Gatos). */
  var SUG = {d:{box:null, sig:null, tok:0, hold:0}, p:{box:null, sig:null, tok:0, hold:0}};
  function jget(u){ return fetch(u).then(function(r){ return r.ok ? r.json() : {}; }).catch(function(){ return {}; }); }
  /* 05/10 (59, D03): o "related" da Shopify devolve a mesma lista para qualquer produto; com território (tipo do
     produto = nome da coleção), as sugestões vêm da coleção dele. Sem território, cai na recomendação nativa. */
  function slug(s){ return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-'); }
  function recs(z){
    var u = '/recommendations/products.json?product_id=' + z.id + '&limit=8&intent=';
    var nat = function(){ return jget(u + 'complementary').then(function(j){
      var l = j.products || []; if(l.length) return {src:'complementary', l:l};
      return jget(u + 'related').then(function(j2){ return {src:'related', l:j2.products || []}; });
    }); };
    if(!z.ty) return nat();
    return jget('/collections/' + slug(z.ty) + '/products.json?limit=50').then(function(j){
      var l = j.products || []; return l.length ? {src:'territorio', l:l} : nat();
    });
  }
  function fam(h){ var m = window.ZF && ZF.m[h]; return m ? 'f' + m[0] : h; }
  function precoHTML(c){ return '<b>' + brl(c) + '</b><span><b>' + brl(pixOf(c)) + '</b> no Pix</span>'; }
  function varHTML(z, v){
    var opts = '';
    if(z.n > 1){
      opts = '<select class="zion-sug__var" hidden aria-label="Opção de ' + esc(z.t) + '">' + (z.vs || []).filter(function(x){ return x.a; }).map(function(x){
        return '<option value="' + x.i + '" data-p="' + x.p + '"' + (x.i === v.i ? ' selected' : '') + '>' + esc(x.t) + ' · ' + brl(x.p) + '</option>';
      }).join('') + '</select>';
    }
    return opts;
  }
  function cardHTML(o){
    var z = o.z, v = (z.vs || []).filter(function(x){ return x.a; })[0] || {i:z.v, p:z.p, a:true};
    return '<li class="zion-sug__card" data-v="' + v.i + '" data-t="' + esc(z.t) + '">'
      + '<a class="zion-sug__media" href="' + esc(z.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(z.img) + '" alt="" width="140" height="105" loading="lazy"></a>'
      + '<div class="zion-sug__body"><h4 class="zion-sug__t"><a href="' + esc(z.u) + '">' + esc(z.t) + '</a></h4><p class="zion-sug__price">' + precoHTML(v.p) + '</p>' + varHTML(z, v) + '</div>'
      + '<div class="zion-sug__buy"><button type="button" class="zion-sug__add" aria-label="Adicionar ' + esc(z.t) + ' ao carrinho">+</button></div></li>';
  }
  function sugBox(list){
    var box = document.createElement('section'); box.className = 'zion-sug'; box.setAttribute('aria-label', 'Sugestões: produtos que não estão no carrinho');
    box.innerHTML = '<div class="zion-sug__h"><p class="zion-sug__k">Sugestões</p><span class="zion-sug__n">Não estão no carrinho</span></div>'
      + '<ul class="zion-sug__track" role="list">' + list.map(cardHTML).join('') + '</ul>'
      + '<p class="zion-sug__live" aria-live="polite"></p>';
    return box;
  }
  function sugestoes(){
    var rs = roots(), kinds = {};
    rs.forEach(function(root){
      kinds[root.kind] = 1;
      var st = SUG[root.kind];
      if($('.zion-hook', root.el)){ if(st.box){ st.box.remove(); st.box = null; } st.sig = null; st.hold = 0; return; }
      var hs = rows(root.el).map(handleOf).filter(Boolean), sig = hs.slice().sort().join(',');
      if(!sig) return;
      if(st.box && (sig === st.sig || st.hold)){
        st.sig = sig;
        if(st.box.parentNode !== root.sug){ root.sug.appendChild(st.box); ext(root.sug); }
        return;
      }
      if(sig === st.sig) return;
      /* 29/10 (C7): a gaveta existe (fechada) em toda página e o reflow roda no load: buscar sugestões ali eram ~8 requisições por página
         sem ninguém ver. Só com a gaveta ABERTA; no /cart, sempre. */
      if(root.kind === 'd' && !gavetaAberta()) return;
      st.sig = sig; var tok = ++st.tok;
      var pinta = function(zl){
        if(tok !== st.tok) return;
        if(st.box){ st.box.remove(); st.box = null; }
        if(!zl.length) return;
        var cur = roots().filter(function(x){ return x.kind === root.kind; })[0]; if(!cur) return;
        st.box = sugBox(zl.map(function(z){ return {z:z}; })); cur.sug.appendChild(st.box); ext(cur.sug);
      };
      /* mesmo carrinho já resolvido nesta sessão (outra página, gaveta reaberta) = 0 requisição */
      var hit = sugCache(sig); if(hit){ pinta(hit); return; }
      var haveH = {}, seen = {};
      hs.forEach(function(h){ haveH[h] = 1; seen[fam(h)] = 1; });
      Promise.all(hs.slice(0, 2).map(getZ)).then(function(zs){
        zs = zs.filter(Boolean);
        return Promise.all(zs.map(recs)).then(function(lists){
          var out = [];
          /* disponibilidade já vem na lista (recomendações: available; coleção: variants[].available): só busca ?view=zcart dos que entram */
          lists.forEach(function(L){ L.l.forEach(function(p){ var f = fam(p.handle); if(haveH[p.handle] || seen[f]) return; if(p.available === false || (p.variants && !p.variants.some(function(v){ return v.available; }))) return; seen[f] = 1; out.push(p.handle); }); });
          return Promise.all(out.slice(0, 3).map(getZ)).then(function(zl){
            zl = zl.filter(function(z){ return z && z.a && !haveH[String(z.u || '').split('?')[0].split('/').pop()]; }).slice(0, 3);
            sugCache(sig, zl); return zl;
          });
        });
      }).then(pinta).catch(function(){});
    });
    ['d', 'p'].forEach(function(k){ if(!kinds[k] && SUG[k].box){ SUG[k].box.remove(); SUG[k].box = null; SUG[k].sig = null; SUG[k].hold = 0; } });
  }
  /* shortcut: cache só da sessão e só do último carrinho; estoque que muda nesse meio tempo é barrado pelo add.js (aviso "Tentar de novo") */
  function sugCache(sig, v){
    try{
      if(v === undefined){ var o = JSON.parse(sessionStorage.getItem('zion_sug') || '{}'); return o.sig === sig ? o.zl : null; }
      sessionStorage.setItem('zion_sug', JSON.stringify({sig:sig, zl:v}));
    }catch(_){ return null; }
  }
  function stOf(el){ return el.closest('.cart-page') ? SUG.p : SUG.d; }
  /* 19/10/2026 (INP): .cart-page.zion-ext no lugar de .cart-page:has(.cart-summary--extend) (margem das sugestões no desktop) */
  function ext(c){ if(c.classList.contains('cart-page')) c.classList.toggle('zion-ext', !!c.querySelector('.cart-summary--extend')); }
  function say(box, t){ var l = box && $('.zion-sug__live', box); if(l){ l.textContent = ''; setTimeout(function(){ l.textContent = t; }, 30); } }
  /* Página /cart: a re-renderização que o Horizon faz depois do updateCart às vezes volta 404 (reproduzido no theme dev
     no celular também SEM este snippet). Se a página não refletir o carrinho em 2,5 s, recarrega: carrinho certo > estado do card. */
  function conferePagina(){
    setTimeout(function(){
      var p = pageCart(); if(!p) return;
      var n = 0; $$('.cart-items__quantity input', p).forEach(function(i){ n += (+i.value || 0); });
      jget('/cart.js').then(function(c){ if(typeof c.item_count === 'number' && c.item_count !== n) location.reload(); });
    }, 2500);
  }
  function updateCart(lines){
    window.__zionSugQuiet = Date.now();
    if(window.Shopify && Shopify.actions && Shopify.actions.updateCart) return Shopify.actions.updateCart({lines:lines}).then(function(res){ if(res && res.userErrors && res.userErrors.length) throw res.userErrors[0]; if(!drawer()) conferePagina(); return res; });
    var l = lines[0];
    return fetch(l.id ? '/cart/change.js' : '/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(l.id ? {id:l.id, quantity:l.quantity} : {id:+l.merchandiseId, quantity:l.quantity})})
      .then(function(r){ if(!r.ok) throw 0; location.reload(); });
  }
  function drop(card){
    var st = stOf(card), box = card.closest('.zion-sug');
    card.classList.add('is-leaving');
    setTimeout(function(){
      card.remove(); st.hold = Math.max(0, st.hold - 1);
      if(box && !$('.zion-sug__card', box)){ box.remove(); if(st.box === box) st.box = null; }
    }, reduce ? 0 : 300);
  }
  document.addEventListener('click', function(e){
    var add = e.target.closest('.zion-sug__add');
    if(add){
      var card = add.closest('.zion-sug__card'), st = stOf(card), box = card.closest('.zion-sug');
      if(card.classList.contains('is-busy')) return;
      /* produto com variante: o 1º toque abre o seletor do card (o change já atualiza preço e data-v); o 2º adiciona */
      var vs = $('.zion-sug__var', card);
      if(vs && vs.hidden){
        vs.hidden = false; card.classList.add('is-pick'); add.textContent = 'Adicionar'; add.setAttribute('aria-label', 'Adicionar ' + card.dataset.t + ' na opção escolhida');
        try{ vs.focus({preventScroll:true}); if(vs.showPicker) vs.showPicker(); }catch(_){}
        return;
      }
      card.classList.add('is-busy'); add.disabled = true; add.textContent = 'Adicionando…';
      st.hold++;
      updateCart([{merchandiseId: String(card.dataset.v), quantity: 1}]).then(function(){
        card.classList.remove('is-busy'); card.classList.add('is-added');
        card._buy = $('.zion-sug__buy', card).innerHTML;
        $('.zion-sug__buy', card).innerHTML = '<p class="zion-sug__ok">' + ICHECK + 'Adicionado</p><button type="button" class="zion-sug__undo">Desfazer</button>';
        say(box, card.dataset.t + ' adicionado ao carrinho. Desfazer disponível por alguns segundos.');
        card._t = setTimeout(function(){ drop(card); }, 7000);
      }).catch(function(){
        card.classList.remove('is-busy'); add.disabled = false; add.textContent = 'Tentar de novo'; st.hold = Math.max(0, st.hold - 1);
        say(box, 'Não foi possível adicionar. Tente de novo.');
      });
      return;
    }
    var undo = e.target.closest('.zion-sug__undo');
    if(undo){
      var card2 = undo.closest('.zion-sug__card'), box2 = card2.closest('.zion-sug'), v = +card2.dataset.v;
      clearTimeout(card2._t); undo.disabled = true;
      jget('/cart.js').then(function(cart){
        var it = (cart.items || []).filter(function(i){ return i.variant_id === v; })[0];
        if(!it) return null;
        return updateCart([{id: it.key, quantity: it.quantity - 1}]);
      }).then(function(){
        card2.classList.remove('is-added');
        $('.zion-sug__buy', card2).innerHTML = card2._buy || '';
        say(box2, card2.dataset.t + ' removido do carrinho.');
        var st2 = stOf(card2); st2.hold = Math.max(0, st2.hold - 1);
      }).catch(function(){ undo.disabled = false; });
    }
  });
  document.addEventListener('click', function(e){
    var hb = e.target.closest('.zion-hook__add'); if(!hb || hb.disabled) return;
    hb.disabled = true; hb.lastChild.textContent = 'Adicionando…';
    updateCart([{merchandiseId: String(hb.dataset.v), quantity: 1}]).catch(function(){ hb.disabled = false; hb.lastChild.textContent = 'Tentar de novo'; });
  });
  document.addEventListener('change', function(e){
    var s = e.target.closest('.zion-sug__var'); if(!s) return;
    var card = s.closest('.zion-sug__card'), o = s.options[s.selectedIndex];
    card.dataset.v = s.value;
    var pr = $('.zion-sug__price', card); if(pr) pr.innerHTML = precoHTML(+o.dataset.p);
  });


  /* 11) gaveta VAZIA (Z15, 05/10/2026): 3 produtos com Adicionar na linha. Fonte, nesta ordem: favoritos (zion_fav),
     vistos (zion_rv, 12-megamenu.py), Seleção Zion. Produto esgotado sai; com mais de uma variante o botão vira "Escolher". */
  var CV = {sig:null, html:null, tok:0, busy:null};
  /* 11/10/2026 (CODIGO-002): a gaveta vazia existe no DOM de toda página (fechada) e o reflow roda a cada mutação: montar as 3 sugestões ali disparava
     /collections/selecao-zion/products.json (1-4x) + até 8x ?view=zcart em TODA carga, e o 429 da Shopify vinha em rajada. Agora só com a gaveta ABERTA
     (vazio() entra no reflow por gavetaAberta()) e uma busca por assinatura por vez (CV.busy), sem reentrar enquanto a primeira não termina. */
  function gavetaAberta(){ var d = drawer(); return !!(d && $('dialog[open]', d)); }
  /* INP: cache em memória (antes: JSON.parse a cada reflow com gaveta vazia); 'storage' invalida (outra aba); zion_fav desta aba é invalidado por zion-mm.js via window.zLSdirty */
  var LSC = {}; addEventListener('storage', function(e){ if(e.key) delete LSC[e.key]; else LSC = {}; }); window.zLSdirty = function(k){ delete LSC[k]; };
  function lsArr(k){ if(k in LSC) return LSC[k].slice(); var r = []; try{ var a = JSON.parse(localStorage.getItem(k) || '[]'); r = Array.isArray(a) ? a.filter(function(h, i){ return h && a.indexOf(h) === i; }) : []; }catch(_){} LSC[k] = r; return r.slice(); }
  function cvHTML(kind, zs, nFav){
    var T = {f:'Seus <strong>favoritos.</strong>', v:'Vistos <strong>por você.</strong>', s:'Comece pela <strong>seleção.</strong>'}[kind];
    return '<section class="zion-cv" aria-label="Sugestões para começar"><h3 class="zion-cv__t">' + T + '</h3><ul class="zion-cv__l" role="list">'
      + zs.map(function(z){
        var b = z.n > 1 ? '<a class="zion-cv__b" href="' + esc(z.u) + '" aria-label="Escolher opções de ' + esc(z.t) + '">Escolher</a>'
          : '<button type="button" class="zion-cv__b" data-v="' + z.v + '" aria-label="Adicionar ' + esc(z.t) + ' ao carrinho">+ Adicionar</button>';
        return '<li class="zion-cv__i"><a href="' + esc(z.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(z.img) + '" alt="" width="64" height="80" loading="lazy"></a>'
          + '<div><div class="zion-cv__n"><a href="' + esc(z.u) + '">' + esc(z.t) + '</a></div><div class="zion-cv__p">' + brl(z.p) + '<br><b>' + brl(pixOf(z.p)) + ' no Pix</b></div></div>' + b + '</li>';
      }).join('') + '</ul>'
      + (kind === 'f' && nFav > 3 ? '<button type="button" class="zion-cv__more" data-zcv-fav>Ver os ' + nFav + ' favoritos</button>' : '')
      + '</section>';
  }
  function cvPick(hs){
    return Promise.all(hs.slice(0, 8).map(getZ)).then(function(zs){ return zs.filter(function(z){ return z && z.a; }).slice(0, 3); });
  }
  function vazio(){
    var d = drawer(), host = d && $('.cart-drawer--empty .cart-drawer__items', d);
    if(!host){ return; }
    var fav = lsArr('zion_fav'), rv = lsArr('zion_rv'), sig = fav.join(',') + '|' + rv.join(',');
    var box = $('.zion-cv', host);
    if(box && sig === CV.sig) return;
    if(!box && sig === CV.sig && CV.html){ host.insertAdjacentHTML('beforeend', CV.html); return; }
    if(CV.busy === sig) return;
    CV.sig = sig; CV.busy = sig; var tok = ++CV.tok;
    cvPick(fav).then(function(zs){
      if(zs.length) return {k:'f', zs:zs};
      return cvPick(rv).then(function(zs2){
        if(zs2.length) return {k:'v', zs:zs2};
        return jget('/collections/selecao-zion/products.json?limit=8').then(function(j){
          return cvPick((j.products || []).map(function(p){ return p.handle; })).then(function(zs3){ return {k:'s', zs:zs3}; });
        });
      });
    }).then(function(r){
      if(tok !== CV.tok || !r.zs.length) return;
      CV.html = cvHTML(r.k, r.zs, fav.length);
      var h = drawer() && $('.cart-drawer--empty .cart-drawer__items', drawer()); if(!h) return;
      var old = $('.zion-cv', h); if(old) old.remove();
      h.insertAdjacentHTML('beforeend', CV.html);
    }).catch(function(){}).then(function(){ if(tok === CV.tok) CV.busy = null; });
  }
  document.addEventListener('click', function(e){
    var more = e.target.closest('[data-zcv-fav]');
    if(more){ var fb = $('.zion-favbtn'); if(fb) fb.click(); return; }
    var b = e.target.closest('.zion-cv__b[data-v]'); if(!b || b.disabled) return;
    b.disabled = true; b.textContent = 'Adicionando…';
    updateCart([{merchandiseId: String(b.dataset.v), quantity: 1}]).catch(function(){ b.disabled = false; b.textContent = 'Tentar de novo'; });
  });

  var applying = false, reflowTimer;
  function reflow(){
    if(applying) return; applying = true;
    try{
      headlines(); roots().forEach(linhas); botoes(); frete(); parcelasTotal(); cupom(); resumo(); selos(); acelerado(); variantes(); sugestoes(); if(gavetaAberta()) vazio(); barraFinal();
    }catch(_){}
    requestAnimationFrame(function(){ applying = false; });
  }
  function schedule(){ clearTimeout(reflowTimer); reflowTimer = setTimeout(reflow, 60); }

  /* Aviso global em qualquer adição FORA da PDP (a PDP tem o próprio, window.__zionPdp) e fora do carrossel
     (que mostra "Adicionado · Desfazer" no próprio card). */
  function init(){
    reflow();
    document.addEventListener('shopify:cart:lines-update', function(e){
      var act = e && e.detail && e.detail.action;
      var quiet = window.__zionSugQuiet && Date.now() - window.__zionSugQuiet < 4000;
      /* 05/10/2026: o Horizon põe a ação no próprio evento (e.action), não em e.detail; lido só do detail, remover caía no "Adicionado" */
      act = e && (e.action || (e.detail && e.detail.action));
      if(act === 'remove'){ if(!quiet) window.zionToast('Removido do carrinho'); }
      else if(!window.__zionPdp && !quiet && (!act || act === 'add')) window.zionToast('Adicionado', {href:'/cart', linkText:'Ver carrinho'});
      schedule();
    });
    document.addEventListener('theme-drawer:open', function(e){ if(e.target && e.target.id === 'cart-drawer') schedule(); });
    if('MutationObserver' in window){
      var onAdd = function(ms){ for(var i = 0; i < ms.length; i++) if(ms[i].addedNodes.length){ schedule(); return; } };   /* só inserção de nós (remoção pura não precisa de reflow); schedule() já coalesce */
      var mo = new MutationObserver(onAdd);
      var d = drawer(); if(d) mo.observe(d, {childList:true, subtree:true});
      var sec = pageCart(); sec = sec && sec.closest('.shopify-section'); if(sec) mo.observe(sec, {childList:true, subtree:true});
      var ds = document.getElementById('shopify-section-cart-drawer-section');
      if(ds && ds.parentNode) new MutationObserver(function(){ var nd = drawer(); if(nd && !nd.__zmo){ nd.__zmo = 1; mo.observe(nd, {childList:true, subtree:true}); } schedule(); }).observe(ds.parentNode, {childList:true});
      if(d) d.__zmo = 1;
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  addEventListener('load', schedule);
  /* INP: a barra de endereço do celular dispara resize o tempo todo; reflow() de 13 passos só quando a LARGURA mudou e o carrinho está em uso */
  var rw = innerWidth; addEventListener('resize', function(){ if(innerWidth === rw) return; rw = innerWidth; if(pageCart() || gavetaAberta()) schedule(); });
})();
